import { GridItem, Text } from "@chakra-ui/react";
import { VStack } from "@chakra-ui/react";

const Section = ({
  children = <></>,
  title,
  colSpan = 1,
}: {
  children?: React.ReactNode;
  title: string;
  colSpan?: number;
}) => (
  <GridItem w="full" gap={4} flexWrap={"wrap"} colSpan={1}>
    <Text w="full" fontWeight={"bold"}>
      {title}
    </Text>
    <VStack>{children}</VStack>
  </GridItem>
);

export default Section;
